export default {
    expiration: localStorage.getItem('expiration') || null,
    loading: [],
    modulos: JSON.parse(localStorage.getItem('modulos')) || null,
    notification: {
        color: null,
        loading: false,
        message: null,
        persistent: true,
        title: null,
        type: null,
        visible: false,
    },
    sidebar: localStorage.getItem('sidebar') === 'true' ? true : false,
    token: localStorage.getItem('token') || null,
    usuario: JSON.parse(localStorage.getItem('usuario')) || null,
}